import { Controller } from "@hotwired/stimulus"

// Asks before a form is submitted. Turbo isn't bundled, so data-turbo-confirm
// does nothing here; this is the working equivalent for a real <form>.
//
// Usage (button_to's `form:` option puts the attributes on the <form>):
//   <form data-controller="confirm"
//         data-confirm-message-value="Delete this?"
//         data-action="submit->confirm#ask">
//
// Values:
//   message — the question to ask.
export default class extends Controller {
  static values = { message: String }

  ask(event) {
    if (!window.confirm(this.messageValue)) event.preventDefault()
  }
}
